/**
 * @param {string} filePath The `filePath` string returned by the Thingtesting API.
 * @param {string} [transformParams] Optional Imagekit style transformation parameters (e.g. `w-64,h-64`).
 * @returns {string}
 */
export const getThingtestingImageUrl = (filePath, transformParams = '') => {
  if (!filePath) return '';
  const base = `https://img.thingtesting.com/${filePath}`;
  let query = '';
  if (transformParams) {
    query = `?tr=${encodeURIComponent(transformParams)}`;
  }
  return `${base}${query}`;
};

/**
 * @param {{type: 'Image'|'Video', filePath: string}} media Media object from the Thingtesting API with `type` and `filePath`.
 * @param {string} [transformParams] Optional Imagekit style transformation parameters (e.g. `w-64,h-64`).
 * @returns {string}
 */
export const getThingtestingMediaImageUrl = (media, transformParams = '') => {
  if (!media) return '';

  switch (media.type) {
    case 'Image':
      return getThingtestingImageUrl(media.filePath, transformParams);
    case 'Video':
      return getThingtestingImageUrl(media.filePath + '/ik-video.mp4/ik-thumbnail.jpg', transformParams);
    default:
      return '';
  }
};
